import React, { useState, useEffect } from "react";
import { SafeAreaView, StyleSheet, ScrollView, View } from "react-native";
import { useTheme } from "react-native-paper";
import CustomAssessment from "../../../components/AssessmentBuilderCmponent/Assessment/CustomAssessment";
import { generateUniqueID } from "../../../components/SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions";

const CreateAssessment = (props) => {
  const { colors } = useTheme();
  const styles = makeStyles(colors);
  const initialQId = generateUniqueID();

  // ! state array of section with containing questions
  const [sectionQuestionList, setSectionQuestionList] = useState([
    {
      id: generateUniqueID(),
      assm_header_id: "",
      section_name: "",
      section_instructions: "",
      section_url_img: "",
      isSectionCover: false,
      graphAxis: "",
      useOnGraph: false,
      section_required_yn: 0,
      section_order: 0,
      section_quantitative: false,
      section_showResults: false,
      section_hideComparison: false,
      section_rotw: "",
      section_weight: 0,
      section_questions: [
        {
          id: initialQId,
          parent_id: "",
          assm_section_id: "",
          input_type_id: generateUniqueID(),
          input_type_name: "",
          question_name: "",
          question_subtext: "",
          question_required_yn: 0,
          answer_required_yn: 0,
          option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
          allow_mutiple_option_answers_yn: 0,
          dependent_question_id: generateUniqueID(),
          dependent_question_option_id: generateUniqueID(),
          dependent_answer_id: generateUniqueID(),
          question_order: 0,
          question_weight: 0,
          questImgUrl: undefined,
          isQuestionCover: false,
          quest_instructions: "",
          question_options: [
            {
              id: generateUniqueID(),
              question_id: initialQId,
              fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
              fk_option_choice_name: "",
              question_option_name: "",
              option_order: 0,
            },
          ],
          question_lines: [
            {
              id: generateUniqueID(),
              question_id: initialQId,
              question_line_description: "",
              question_line_order: 0,
              question_line_required_yn: false,
              input_type_id: generateUniqueID(),
              input_type_name: "",
              weight: 0,
            },
          ],
        },
      ],
    },
  ]);
  return (
    <SafeAreaView style={[styles.main]}>
       <View style={styles.listWrapper}>
      <CustomAssessment
        groups={props.data[0]}
        company={props.data[1]}
        workflows={props.data[2]}
        question_types={props.data[3]}
        setWfl={props.setWfl}
        assm={props.assm}
        setAssm={props.setAssm}
        setAssmUi={props.setAssmUi}
        assmUi={props.assmUi}
        sectionQuestionList={sectionQuestionList}
        setSectionQuestionList={setSectionQuestionList}
        setShowParticipationsScreen={props.setShowParticipationsScreen}
        setShowResponseScreen={props.setShowResponseScreen}
        setShowEditScreen={props.setShowEditScreen}
        setShowEditGroup={props.setShowEditGroup}
        setShowCreateScreen={props.setShowCreateScreen}
        setShowCreateGroup={props.setShowCreateGroup}
        setShowMyAssessments={props.setShowMyAssessments}
        isCreate={1}
        toView={0}
        setShowAssessmentsAdmin={props.setShowAssessmentsAdmin}
      />
      </View>
    </SafeAreaView>
  );
};

const makeStyles = (colors, height, width) =>
  StyleSheet.create({
    main: {
      flex: 1,
    },
    listWrapper: {
      flex:1,
      padding:10,
      marginHorizontal:8,
      marginBottom: 10
  }, 
    row_elements: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "center",
      margin: "1%",
      borderRadius: 5,
      elevation: 5,
      shadowOffset: { width: 0, height: 0 },
      backgroundColor: colors.background_card,
    },
  });

export default CreateAssessment;